import API_URL from "@/constant/api.config";
import axios from "axios";

export const getHeroBanners = async () => {
    const response = await axios.get(API_URL + "/heroBanner");
    return response.data ? response.data.data : [];
}

export const getOurPartners = async (limit = 0) => {
    const response = await axios.get(API_URL + "/image-our-partners/" + limit);
    return response.data ? response.data.data : [];
}

export const getPromotionPartners = async () => {
    const response = await axios.get(API_URL + "/promotion-media");
    return response.data ? response.data.data : [];
}

export const getMockInquiry = async () => {
    const response = await axios.get(API_URL + "/mockInquiry");
    return response.data ? response.data.data : [];
}

export const getTestimonials = async () => {
    const response = await axios.get(API_URL + "/testimonial");
    return response.data ? response.data.data : [];
}